import React, { useMemo } from 'react';

// DEPENDENCIES
import format from 'date-fns/format';
import endOfMonth from 'date-fns/endOfMonth';
import { createPortal } from 'react-dom';

// GLOBAL VARIABLES
import { ENDPOINTS } from 'endpoints';

// GLOBAL FUNCTIONS
import { formatDate, makePath } from 'functions.js';

// HOOKS
import { useRecordContext } from 'helpers/getRecordData';
import { useSalesStatus } from '../hooks/useSalesStatus';

// CORE COMPONENTS
import Form from 'core/form/Form';

// GLOBAL PARTS
import Sidebar from 'parts/sidebar/Sidebar';

// MAIN COMPONENT
const CarryoverSidebar = () => {

  // HOOKS
  const { refetchRecord, record: { inventory: { stock_num } = {} } = {}, recordID } = useRecordContext();
  const { deliveredDate } = useSalesStatus();

  // MEMOS
  const [
    today,
    lastDay,
    deliveredMonth
  ] = useMemo(
    () => [
      formatDate(new Date()),
      formatDate(endOfMonth(new Date(deliveredDate))),
      format(new Date(deliveredDate), 'MMMM, yyyy')
    ],
    [deliveredDate]
  );

  // RENDER
  return createPortal(
    <Sidebar
      name="carryoverSidebar"
      title="Carryover"
    >
      <Sidebar.Form
        method="PUT"
        endpoint={makePath(ENDPOINTS.sales.carryover, recordID)}
        onSuccess={() => refetchRecord()}
        loadingMessage={`Carring over Stock# ${stock_num}`}
        successMessage="Sales has been carried over to current month."
        errorMessage={`Failed to Carryover Stock# ${stock_num}`}
      >
        <Form.Col>
          <p><big>By carrying over this deal (Stock# {stock_num}) to {today}, the deal will be backed out on the last day of the
          month ({lastDay}) of the original sold date. The total units for {deliveredMonth} will be affected by one less
          unit. However, the deal will be reflected in the current month's count. Are you sure you want to Carryover this
          deal?</big></p>
        </Form.Col>
      </Sidebar.Form>
    </Sidebar>,
    document.body
  );  
}
const CarryoverSidebarButton = props => {

  // HOOKS
  const { isCarryover, carryoverDisabled } = useSalesStatus();

  // RENDER
  return (
    <Sidebar.Button
      name="carryoverSidebar"
      disabled={isCarryover || carryoverDisabled}
      label="Carryover"
      icon="arrow-right"
      {...props}
    />
  )  
}
CarryoverSidebar.Button = CarryoverSidebarButton;

// EXPORT
export default CarryoverSidebar;
